export default {
  purple: '#7300fc',
  purpleLight: '#b97ffd',
  yellow: '#fdc500',
  yellowLight: '#fee27f',
  gray: '#191919',
  grayLight: '#949594',
  greenLight: '#75fdc7',
  green: '#12FC9E',
  greenDark: '#12FC6C',
  pink: '#FF056F',
  whiteLight: '#f2f3f7',
  white: '#ffffff',
};
